import React, { useState, useEffect } from "react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { generateFullImageUrl } from "../../../../utilities/utils";

const ProfileInsuranceDetail = ({
  insuranceDetails,
  selectedInsuranceDetails,
  formik,
  setActiveButtonValue,
  handleSelectInsurance,
  handleResetInsurance,
}) => {
  const isMobile =
    window.matchMedia &&
    window.matchMedia("only screen and (max-width: 767px)").matches;

  const [activeButton, setActiveButton] = useState(
    insuranceDetails ? "yes" : "no"
  );
  const [showInsuranceOptions, setShowInsuranceOptions] = useState(
    activeButton === "yes"
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredInsurances, setFilteredInsurances] =
    useState(insuranceDetails);
  const [selectedOptions, setSelectedOptions] = useState(
    formik && formik?.values?.insuranceOptions
  );
  const [selectedInsuranceName, setSelectedInsuranceName] = useState(
    selectedInsuranceDetails && selectedInsuranceDetails
  );

  useEffect(() => {
    if (insuranceDetails) {
      setFilteredInsurances(insuranceDetails);

      // Update showInsuranceOptions based on activeButton
      setShowInsuranceOptions(activeButton === "yes");
    }
  }, [insuranceDetails, activeButton]);

  useEffect(() => {
    if (selectedInsuranceDetails && selectedInsuranceDetails.length > 0) {
      setSelectedOptions(selectedInsuranceDetails.map((item) => item.id));
      setSelectedInsuranceName(selectedInsuranceDetails.map((item) => item));
      setShowInsuranceOptions(true);
      setActiveButton("yes");
    } else {
      setSelectedOptions([]);
      setSelectedInsuranceName([]);
      setShowInsuranceOptions(false);
      setActiveButton("no");
    }
  }, [selectedInsuranceDetails]);

  useEffect(() => {
    if (insuranceDetails) {
      setFilteredInsurances(insuranceDetails);
    }
  }, [insuranceDetails]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    const filtered = insuranceDetails.filter((insurance) =>
      insurance?.name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredInsurances(filtered);
  };

  const handleButtonClick = (value) => {
    setActiveButton(value);
    setActiveButtonValue && setActiveButtonValue(value);
    if (value === "yes") {
      setShowInsuranceOptions(true);
      setSelectedOptions(selectedInsuranceDetails?.map((item) => item.id));
      handleResetInsurance && handleResetInsurance("yes");
    } else {
      setSelectedOptions([]);
      handleResetInsurance && handleResetInsurance("no");
      setShowInsuranceOptions(false);
    }
  };

  const handleCheckboxChange = (insuranceId) => {
    const newSelectedOptions = [...selectedOptions];
    if (newSelectedOptions.includes(insuranceId)) {
      const index = newSelectedOptions.indexOf(insuranceId);
      newSelectedOptions.splice(index, 1);
    } else {
      newSelectedOptions.push(insuranceId);
    }
    formik.setFieldValue &&
      formik.setFieldValue("insuranceOptions", newSelectedOptions);
    setSelectedOptions(newSelectedOptions);
    let filteredSelectedOptions = insuranceDetails.filter((insurance) =>
      newSelectedOptions.includes(insurance.id)
    );
    setSelectedInsuranceName(filteredSelectedOptions);
    handleSelectInsurance && handleSelectInsurance(filteredSelectedOptions);
    setSearchQuery("")
    setFilteredInsurances(insuranceDetails);
  };

  const getIsOptionSelected = (id) => {
    const response = selectedOptions && selectedOptions.includes(id);
    return response;
  };

  const handleRemoveItem = (idToRemove) => {
    const updatedSelectedInsuranceName = selectedInsuranceName.filter(
      (insurance) => insurance.id !== idToRemove
    );
    const indexToRemove = selectedOptions.indexOf(idToRemove);
    if (indexToRemove !== -1) {
      selectedOptions.splice(indexToRemove, 1);
    }
    setSelectedInsuranceName(updatedSelectedInsuranceName);
    setSelectedOptions([...selectedOptions]);
    handleSelectInsurance &&
      handleSelectInsurance(updatedSelectedInsuranceName);
  };

  const buttonStyleYes = {
    backgroundColor: activeButton === "yes" ? "#1E90FE" : "",
    color: activeButton === "yes" ? "white" : "black",
  };

  const buttonStyleNo = {
    backgroundColor: activeButton === "no" ? "#1E90FE" : "",
    color: activeButton === "no" ? "white" : "black",
  };

  return (
    <div>
      <div className="grid md:items-center grid-cols-1 md:grid-cols-2 gap-5 xl:gap-[70px] pt-6 pb-5">
        <h6 className="text-xs font-bold leading-[160%] uppercase text-customGray">
          Do you accept insurance?
        </h6>
        <div className="flex items-center gap-[14px]">
          <button
            className="text-base font-medium leading-[160%] text-white border border-solid border-[#EBEFF3] rounded-[10px] py-[6px] px-[18px]"
            style={buttonStyleYes}
            onClick={() => handleButtonClick("yes")}
          >
            Yes
          </button>
          <button
            className="text-base font-medium leading-[160%] text-customGray border border-solid border-[#EBEFF3] rounded-[10px] py-[6px] px-[18px]"
            style={buttonStyleNo}
            onClick={() => handleButtonClick("no")}
          >
            No
          </button>
        </div>
      </div>
      {showInsuranceOptions && (
        <div className="border-t pt-5 grid grid-cols-1 xl:grid-cols-2 gap-5 xl:gap-[70px]">
          <div className="">
            <h6 className="text-xs font-bold leading-[160%] uppercase text-customGray mb-[6px]">
              Insurance you accept
            </h6>
            <p className="text-sm leading-[160%] text-[#485868] mb-[22px]">
              Please select all insurance carriers that you accept any plan
              under.
            </p>
            <ul className="flex items-center gap-4 flex-wrap">
              {selectedInsuranceName &&
                selectedInsuranceName?.map((insurance) => (
                  <li className="flex items-center gap-2.5 h-10 text-xs font-medium leading-[160%] text-customGray p-2.5 rounded-[10px] bg-[#F1F4F6]">
                    {insurance.name}{" "}
                    <XMarkIcon
                      className="w-4 h-4 text-[#768B9F] cursor-pointer"
                      onClick={() => handleRemoveItem(insurance.id)}
                    />
                  </li>
                ))}
            </ul>
          </div>
          <form onSubmit={formik && formik.handleSubmit}>
            <div className="mr-2">
              <div className="flex items-center mx-auto w-full border border-solid border-[#CCD0D4] rounded-[10px] h-[48px] bg-white mb-3">
                <span className="pl-[14px] md:pl-[16px] pr-[10px]">
                  <MagnifyingGlassIcon className="w-6 h-6 text-[#485868]" />
                </span>
                <input
                  type="text"
                  name="search-carrier"
                  onChange={handleSearchChange}
                  value={searchQuery}
                  placeholder="Type to find carriers..."
                  className="border-r-0 text-sm font-normal text-customGray placeholder:text-[#869099] bg-transparent"
                />
              </div>
              {formik?.errors?.insuranceOptions && (
                <div className="text-red-500 text-sm font-medium my-2">
                  {formik?.errors?.insuranceOptions}
                </div>
              )}
              {isMobile && searchQuery && (
                <ul className="scroller max-h-[500px] overflow-y-auto pr-1">
                  {filteredInsurances &&
                    filteredInsurances?.map((insurance) => (
                      <li
                        key={insurance.id}
                        className={`form-group flex items-center border border-solid cursor-pointer border-[#CCD0D4] rounded-[10px] min-h-[48px] py-[11px] px-4 mb-3 ${
                          getIsOptionSelected(insurance.id)
                            ? "border-primary border-[1.5px]"
                            : "border-[#CCD0D4]"
                        }`}
                        onClick={() => handleCheckboxChange(insurance.id)}
                      >
                        <div className="flex items-center relative">
                          <input
                            id={`option-${insurance.id}`}
                            aria-describedby="comments-description"
                            name="insuranceOptions"
                            type="checkbox"
                            checked={
                              selectedOptions &&
                              selectedOptions.includes(insurance.id)
                            }
                            onChange={() => handleCheckboxChange(insurance.id)}
                            className="rounded border-[1.5px] border-[#CCD0D4] relative cursor-pointer inline-block w-5 h-5 leading-[0px]"
                          />
                        </div>
                        <div className="min-w-0 flex-1 text-sm leading-6 pl-[14px]">
                          <label
                            // htmlFor={`option-${insurance.id}`}
                            className="font-medium text-customGray text-sm md:text-base leading-[160%] cursor-pointer"
                          >
                            {insurance.name}
                          </label>
                        </div>
                        {/* <div className="w-[50px]">
                          <img
                            src={generateFullImageUrl(insurance?.photo)}
                            alt=""
                          />
                        </div> */}
                      </li>
                    ))}
                </ul>
              )}
              {!isMobile && (
                <ul className="scroller max-h-[500px] overflow-y-auto pr-1">
                  {filteredInsurances &&
                    filteredInsurances?.map((insurance) => (
                      <li
                        key={insurance.id}
                        className={`form-group flex items-center border border-solid cursor-pointer border-[#CCD0D4] rounded-[10px] min-h-[48px] py-[11px] px-4 mb-3 ${
                          getIsOptionSelected(insurance.id)
                            ? "border-primary border-[1.5px]"
                            : "border-[#CCD0D4]"
                        }`}
                        onClick={() => handleCheckboxChange(insurance.id)}
                      >
                        <div className="flex items-center relative">
                          <input
                            id={`option-${insurance.id}`}
                            aria-describedby="comments-description"
                            name="insuranceOptions"
                            type="checkbox"
                            checked={
                              selectedOptions &&
                              selectedOptions.includes(insurance.id)
                            }
                            onChange={() => handleCheckboxChange(insurance.id)}
                            className="rounded border-[1.5px] border-[#CCD0D4] relative cursor-pointer inline-block w-5 h-5 leading-[0px]"
                          />
                        </div>
                        <div className="min-w-0 flex-1 text-sm leading-6 pl-[14px]">
                          <label
                            // htmlFor={`option-${insurance.id}`}
                            className="font-medium text-customGray text-sm md:text-base leading-[160%] cursor-pointer"
                          >
                            {insurance.name}
                          </label>
                        </div>
                        {/* <div className="w-[50px]">
                          <img
                            src={generateFullImageUrl(insurance?.photo)}
                            alt=""
                          />
                        </div> */}
                      </li>
                    ))}
                </ul>
              )}
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

ProfileInsuranceDetail.defaultProps = {
  insuranceDetails: [],
  formik: () => {},
};
export default ProfileInsuranceDetail;
